var map = {
	"./a-min.png": 67697,
	"./b-min.png": 8098,
	"./c-min.png": 58603,
	"./d-min.png": 34102,
	"./e-min.png": 81349,
	"./f-min.png": 75868,
	"./g-min.png": 45946,
	"./h-min.png": 92254,
	"./i-min.png": 9536,
	"./j-min.png": 40165,
	"./k-min.png": 99189,
	"./l-min.png": 60372,
	"./m-min.png": 18454,
	"./n-min.png": 17946,
	"./o-min.png": 71210,
	"./p-min.png": 31183,
	"./r-min.png": 27478,
	"./s-min.png": 46076,
	"./t-min.png": 2775,
	"./u-min.png": 68790,
	"assets/tables/matematyka/a-min.png": 67697,
	"assets/tables/matematyka/b-min.png": 8098,
	"assets/tables/matematyka/c-min.png": 58603,
	"assets/tables/matematyka/d-min.png": 34102,
	"assets/tables/matematyka/e-min.png": 81349,
	"assets/tables/matematyka/f-min.png": 75868,
	"assets/tables/matematyka/g-min.png": 45946,
	"assets/tables/matematyka/h-min.png": 92254,
	"assets/tables/matematyka/i-min.png": 9536,
	"assets/tables/matematyka/j-min.png": 40165,
	"assets/tables/matematyka/k-min.png": 99189,
	"assets/tables/matematyka/l-min.png": 60372,
	"assets/tables/matematyka/m-min.png": 18454,
	"assets/tables/matematyka/n-min.png": 17946,
	"assets/tables/matematyka/o-min.png": 71210,
	"assets/tables/matematyka/p-min.png": 31183,
	"assets/tables/matematyka/r-min.png": 27478,
	"assets/tables/matematyka/s-min.png": 46076,
	"assets/tables/matematyka/t-min.png": 2775,
	"assets/tables/matematyka/u-min.png": 68790
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58378;